import {makeStyles} from "@mui/styles";
import React, {useState} from "react";


export const useOrderStyles = makeStyles(() => ({
  firstRow: {
    marginTop: 12,
  },
}));
